// Las dos voces de la casa: lo que suena cuando un personaje abre la boca.
//
// POR QUÉ SALEN DE `lib/sound.js`. Porque ese fichero está clavado en las cuatrocientas líneas
// del trinquete y el 6 de octubre de 2026 hizo falta una voz más —la de Sócrates reaccionando en
// su tranvía—. El trinquete dice lo que hay que hacer cuando un fichero tiene que crecer: *«se
// parte primero»*, y el corte estaba clarísimo porque acababa de aparecer: **hasta hoy había una
// voz y ahora hay dos.** En cuanto son dos, «cómo suena alguien hablando» deja de ser un detalle
// del reproductor y pasa a ser una cosa con nombre.
//
// ES EL MISMO PATRÓN QUE `sonidosDelMundo.js`, que ya se llevó la lira, la compuerta y el
// despegue: la receta vive fuera y recibe el reproductor. Aquí no hay motor nuevo —son los
// `_tone` de siempre—, así que las dos respetan el botón de silencio y comparten el mismo
// `AudioContext` que el resto. Un segundo reproductor acabaría con dos sonando a la vez el día
// que alguien navegue deprisa, que es lo que esta casa ya decidió con la música ambiente.
//
// QUÉ NOTAS Y POR QUÉ, en `lib/vozAlpha.mjs` y `lib/vozDeSocrates.mjs`. Aquí sólo está el cable.

import { frase } from "./vozAlpha.mjs";
import { gesto } from "./vozDeSocrates.mjs";

/** Suelta una tira de sílabas por el reproductor. Las dos voces son esto con otra receta. */
const silabea = (s, silabas) => silabas.forEach((x) => s._tone({
  freq: x.hz, to: x.hasta, type: "triangle", dur: x.dura, gain: x.fuerza, when: x.cuando,
}));

/**
 * La voz de Alpha, quien vive en la isla: unas sílabas sin palabras.
 *
 * `semilla` es de qué habla: el mismo texto suena siempre igual.
 */
export const vozDeAlpha = (s, semilla) => silabea(s, frase(semilla));

/**
 * Y lo que hace Sócrates con la boca al contestarle en el tranvía: un «mmm», un «uuh», un
 * «ajá». Grave, en re dórico, y **sin decir nunca «muy bien»**: ese juego no tiene aciertos.
 */
export const vozDeSocrates = (s, cual) => silabea(s, gesto(cual));
